import { splitToChunks } from 'core/helpers/arrays'
import { firestore } from '..'
import firebase from 'firebase/compat/app'
import { AssetType, BaseAssetType } from 'core/logic/asset/asset.types'
import { FirestoreErrorCode } from 'firebase/firestore'

// Firestore - Asset constants
const ASSETS_PATH = `tenants/${process.env.REACT_APP_TENANT_IDENTITY_ID}/assets`

export const fetchAssetsByTokens = async ({
  tokenIds,
}: {
  tokenIds: (string | number)[]
}) => {
  const chunks = splitToChunks(tokenIds, 10)
  const promises = chunks.map((chunk) =>
    firestore.collection(ASSETS_PATH).where('tokenId', 'in', chunk).get()
  )
  const result = await Promise.all(promises)
  const singleArray = result.reduce(
    (acc, cur) => acc.concat(cur.docs),
    [] as firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData>[]
  )

  return singleArray.map((doc) => {
    const data = doc.data()
    const id = doc.id
    return {
      ...(data as AssetType),
      id,
      created: new Date(data.created),
    }
  })
}

export const fetchAssetsByCIDs = async (cids: string[]) => {
  const chunks = splitToChunks(cids, 10)
  const promises = chunks.map((chunk) =>
    firestore.collection(ASSETS_PATH).where('ipfs.jsonHash', 'in', chunk).get()
  )
  const result = await Promise.all(promises)
  const docs = result.reduce(
    (acc, cur) => acc.concat(cur.docs),
    [] as firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData>[]
  )
  return docs.map((doc) => {
    const data = doc.data()
    const id = doc.id
    return {
      ...(data as BaseAssetType),
      id,
      created: new Date(data.created),
    }
  })
}

export const fetchAssetsByIDs = async (ids: string[]) => {
  const chunks = splitToChunks(ids, 10)
  const promises = chunks.map((chunk) =>
    firestore
      .collection(ASSETS_PATH)
      .where(firebase.firestore.FieldPath.documentId(), 'in', chunk)
      .get()
  )
  const result = await Promise.all(promises)
  const docs = result.reduce(
    (acc, cur) => acc.concat(cur.docs),
    [] as firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData>[]
  )
  return docs.map((doc) => {
    const data = doc.data()
    const id = doc.id
    return {
      ...(data as BaseAssetType),
      id,
      created: new Date(data.created),
    }
  })
}

export const fetchAssets = async (fromCache: boolean = false) => {
  const result = await firestore
    .collection(ASSETS_PATH)
    .where('status', 'in', ['PUBLISHED', 'UPDATED', 'PINNED'])
    .orderBy('created')
    .get(fromCache ? { source: 'cache' } : undefined)
  return result
}

export const fetchAssetsDocs = async (fromCache: boolean = false) => {
  const res = await fetchAssets(fromCache)
  return res.docs.map((doc) => {
    const data = doc.data()
    const id = doc.id
    return {
      ...(data as AssetType),
      id,
      created: new Date(data.created),
    }
  })
}

export const fetchAsset = ({ assetId }: { assetId: string }) => {
  return firestore.collection(ASSETS_PATH).doc(assetId).get()
}
